import React from 'react'
import { useQuery } from 'react-apollo'
import PropTypes from 'prop-types'

import Error from '../Error/Error'
import Progress from '../Progress/Progress'
import { OUTPOST_INFO } from './RestaurantInfo.graphql'
import RestaurantAddress from '../RestaurantAddress/RestaurantAddress'
import './RestaurantInfo.css'
import { PageHeader } from '../PageHeader/PageHeader'
import { FulfillmentDisplay } from '../FulfillmentDisplay/FulfillmentDisplay'
import { IfOutpost, UnlessOutpost } from '../IfOutpost/IfOutpost'
import { useOutpost } from '../OutpostProvider/OutpostProvider'
import { useRestaurant } from '../RestaurantProvider/RestaurantProvider'

const RestaurantInfo = ({ header, showDeliveryAddress = false }) => {
  const { restaurantInfo } = useRestaurant()
  const { isOutpost, diningOptionGuid = null } = useOutpost()
  const outpostInfo = useQuery(OUTPOST_INFO, {
    variables: {
      isOutpost,
      outpostRestaurantInput: {
        diningOptionGuid
      }
    },
    skip: !isOutpost
  })

  const loading = outpostInfo.loading || restaurantInfo.loading
  const error = outpostInfo.error || restaurantInfo.error
  if (loading) return <Progress eventData={{category: 'Restaurant Info'}} />
  if (error) return <Error error={error} />

  const { outpostRestaurant } = isOutpost ? outpostInfo.data : {}
  const { location, whiteLabelName } = restaurantInfo.data.restaurant

  return (
    <div styleName='info'>
      <PageHeader header={header} />
      <p styleName='name'>{whiteLabelName}</p>
      <RestaurantAddress
        address1={location.address1}
        address2={location.address2}
        city={location.city}
        state={location.state}
      />
      <IfOutpost>
        <div styleName='fulfillment'>
          <FulfillmentDisplay
            showDeliveryAddress={showDeliveryAddress}
            outpostName={outpostRestaurant ? outpostRestaurant.outpost.outpostName : null}
            outpostDeliveryTime={outpostRestaurant && outpostRestaurant.daySchedule ? outpostRestaurant.daySchedule.deliveryTime : null} />
        </div>
      </IfOutpost>
      <UnlessOutpost>
        <div styleName='fulfillment'>
          <FulfillmentDisplay showDeliveryAddress={showDeliveryAddress} />
        </div>
      </UnlessOutpost>
    </div>
  )
}

RestaurantInfo.propTypes = {
  header: PropTypes.string.isRequired,
  showDeliveryAddress: PropTypes.bool
}

export default React.memo(RestaurantInfo)
